import { render, staticRenderFns } from "./TaskNewsAside.vue?vue&type=template&id=809093ba&lang=pug"
import script from "./TaskNewsAside.vue?vue&type=script&lang=ts"
export * from "./TaskNewsAside.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports